import { render, staticRenderFns } from "./ReclamationExternal.vue?vue&type=template&id=018f7b3e&"
import script from "./ReclamationExternal.vue?vue&type=script&lang=js&"
export * from "./ReclamationExternal.vue?vue&type=script&lang=js&"
import style0 from "./ReclamationExternal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports